const checkDrawercart = setInterval(function() {
  if (document.body.classList.contains('loaded')) {
    // head
     $(document).on("click", ".site-header__cart-toggle", function() {
        event.preventDefault();
        openCartDrawer();
         });
    
  // 提交购物车表单
      
 $(document).on("click", ".custom-cartdrawer_submit", function() {
    event.preventDefault(); // 阻止默认提交
    const form = $(this).closest('form'); // 获取当前按钮所在的表单
    
    if (form.hasClass('CartAddToCartForm')) {
      form.addClass('activeform');
      $(".drawer__footer").addClass("active-drawer__footer");
    }
    
    $('body').addClass('right-cart-hide');
    const formData = form.serialize(); // 序列化表单数据
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: formData,
      dataType: 'json',
      success: function(response) {
        if (response.status) {
          console.error(response.description);
          return;
        }        
            // 检查父级 form 中是否存在 .custom-addons-row
            if (form.find('.custom-addons-row').length > 0) {
                const addonsInput = document.getElementById('addons-input');
                const addonsId = addonsInput.getAttribute('addonsid');                
                if (addonsInput.classList.contains('input-check')) {
                    setTimeout(() => {
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: {
                                id: addonsId,
                                quantity: 1
                            },
                            dataType: 'json',
                            success: function() {
                                $("#addons-input").removeClass('input-check'); 
                                $("#addons-input").prop('checked', false);
                              setTimeout(function() {
                                updateCartDrawer(); // 更新购物车内容
                                openCartDrawer(); // 打开购物车
                                $('body').removeClass('right-cart-hide');
                              }, 400);
                            },
                            error: function() {
                                console.error('添加额外产品失败');
                            }
                        });
                    }, 500);
                }
                else{
                setTimeout(function() {
                  updateCartDrawer(); // 更新购物车内容
                  openCartDrawer(); // 打开购物车
                  $('body').removeClass('right-cart-hide');
                }, 200);
                  
                }
            }
        else{
            setTimeout(function() {
              updateCartDrawer(); // 更新购物车内容
              openCartDrawer(); // 打开购物车
              $('body').removeClass('right-cart-hide');
            }, 400);
          
        }
        
      },
      error: function(error) {
        console.error('Error:', error);
      }
    });
  });

$('.pf-product-form button').on('click', function () {
    console.log("ceshi pf-product-form2");   
    $('body').addClass('right-cart-hide');
   // $('.right-drawer-section').css('display','none');
  var intervalId = setInterval(function () {
    if ($('.right-drawer-vue .drawer--cart').length > 0) {
      $('.drawer__close button').click();      
      updateCartDrawer();
      setTimeout(function() { 
          openCartDrawer(); 
          $('body').removeClass('right-cart-hide');
      }, 400);
      clearInterval(intervalId);
    }
  }, 500);
      
   
})
    
  // 更新购物车抽屉
  function updateCartDrawer() {
    
  //   var currentPageUrl = window.location.href;
  
  // // 使用当前页面的 URL 发起请求
  //  $.get(currentPageUrl, function(data) {
    $.get('/cart', function(data) {
    const $tempElement = $('<div>').html(data);
    $('cart-drawer').html($tempElement.find('cart-drawer').html());

    $('.cart-icon-text').html($tempElement.find('.cart-icon-text').html());
    
    $('.gift-threshold-banner').html($tempElement.find('.gift-threshold-banner').html());
      
      newContrlCartDrawer();
    }).fail(function(error) {
      console.error('Error updating cart:', error);
        // $('.custom-drawer__header').css('background','#ff005e');
    });

  }

  // 打开购物车
  function openCartDrawer() {
    $('cart-drawer').addClass('active'); // 添加 active 类
    $('body').addClass('no-scroll');    
    changeReviews();
  }
    
  function closeCartDrawer() {
    $('cart-drawer').removeClass('active');  
    $('body').removeClass('no-scroll');  
  }

  // 控制购物车的功能
function newContrlCartDrawer() {
    // 清除旧的事件处理程序
    $(document).off("click", ".drawer__close");
    $(document).off("click", ".cart-drawer__overlay");
    $(document).off("click", ".quantity-increase");
    $(document).off("click", ".quantity-decrease");
    $(document).off("click", ".cart-remove-button");
    $(document).off("click", "#cart-drawer-apply-discount");
    $(document).off("click", ".cart-drawer-removecode");

  

    var swatchElementpro = document.querySelector('.cart-custom-swatch');
    if (swatchElementpro) {
        $('.cart-custom-swatch').each(function() {
              
        $(this).find(".swatch-element.default_plug  label").trigger('click');
        $(this).find(".swatch-element.default_plug").attr('custom-current', 'currency-variant');
    
          
        var swatchElementpro = $(this);
        var sortOrder = swatchElementpro.find('.custom_plug_sort').text().split(',');
    
        // 获取当前 swatch 中的所有 swatch-element 元素
        var $swatchElements = swatchElementpro.find('.swatch-items-wrapper .swatch-element');
    
        // 根据指定顺序排序元素
        $swatchElements.sort(function(a, b) {
            var aValue = $(a).data('value');
            var bValue = $(b).data('value');
            return sortOrder.indexOf(aValue) - sortOrder.indexOf(bValue);
        });
    
        // 清空当前 swatch-items-wrapper 并重新添加排序后的元素
        swatchElementpro.find('.swatch-items-wrapper').empty().append($swatchElements);   
          
    });       
    }

    // 关闭购物车
    $(document).on("click", ".drawer__close", function() {
        closeCartDrawer(); 
    });
    
    $(document).on("click", ".cart-drawer__overlay", function() {
        closeCartDrawer(); 
    });

    // 数量增加
    $(document).on("click", ".quantity-increase", function(event) {
        const $quantityInput = $(this).prev('.quantity__input'); // 确保选择正确的输入框
        let currentQuantity = parseInt($quantityInput.val());
        $quantityInput.val(currentQuantity + 1); // 增加数量
        
        $(this).closest('.cart-item').addClass("active-cart-item");
        $(".drawer__footer").addClass("active-drawer__footer");
        const lineItemId = $(this).data('index'); // 获取产品行的 ID
        updateCartDrawerQuantity(lineItemId, $quantityInput.val()); // 更新购物车数量
    });

    // 数量减少
    $(document).on("click", ".quantity-decrease", function(event) {
        const $quantityInput = $(this).next('.quantity__input'); // 确保选择正确的输入框
        let currentQuantity = parseInt($quantityInput.val());
        
        $(this).closest('.cart-item').addClass("active-cart-item");
        $(".drawer__footer").addClass("active-drawer__footer");
        if (currentQuantity > 1) {
            $quantityInput.val(currentQuantity - 1); // 减少数量
            const lineItemId = $(this).data('index'); // 获取产品行的 ID
            updateCartDrawerQuantity(lineItemId, $quantityInput.val()); // 更新购物车数量
        } else {
            // 如果数量为1，删除产品
            const lineItemId = $(this).data('index'); // 获取产品行的 ID
            removeCartDrawerItem(lineItemId);
        }
    });

    // 删除功能
    $(document).on("click", ".cart-remove-button", function(event) {
        event.preventDefault(); // 阻止默认行为
        const itemId = $(this).data('index');       
        $(this).closest('.cart-item').addClass("active-remove-cart-item");
        $(".drawer__footer").addClass("active-drawer__footer");
        removeCartDrawerItem(itemId);
    });

   
          

  // freegift
        var labelData = parseInt($(".custom-drawer .free-label").attr('label-data'), 10);
        var freeGiftId = $(".custom-drawer .free-label").attr('free-gift-id');
        var freeGiftQuantity = $(".freegift-content").attr('free-quantity');
        var freeitemId = $('.freegift-content').data('index');

        if (labelData <= 0) {
            // 获取当前购物车内容
          if (!$('.freegift-content').length) {
          $(".drawer__footer").addClass("active-drawer__footer");
            addProductToCart(freeGiftId, 1);
          }
          
          if ($('.freegift-content').length && freeGiftQuantity > 1) {  
          $(".drawer__footer").addClass("active-drawer__footer");          
            updateCartDrawerQuantity(freeitemId, 1); 
          }
          
        } else {
          if ($('.freegift-content').length) {// 获取产品 ID
          $(".drawer__footer").addClass("active-drawer__footer");
            removeCartDrawerItem(freeitemId);
          }
        }


  

    $(document).on("click", "#cart-drawer-apply-discount", function(event) {
        event.preventDefault();
        $(".drawer__footer").addClass("active-drawer__footer");

        // 获取用户输入的折扣码
        var discountCode = $('#cart-drawer-discount-input').val().trim().toLowerCase();
        if (!discountCode) return;

        var discountSpan = $('#cart-drawer-discount-code-box');
        if (discountSpan.find('.cart-drawer-discount-code-box-span ').length === 0) {
            var url = '/checkout?discount=' + encodeURIComponent(discountCode);

            $.get(url, function(data, status) {
                $('#cart-drawer-discount-input').val('');

                    var discountAfter = discountSpan.find('.cart-drawer-discount-code-title');
                    var titlesParam1 = discountAfter.map(function() {
                        return $(this).text().trim().toLowerCase();
                    }).get().join(',');

                    if (!titlesParam1.includes(discountCode)) {
                        var discountInfoText = $('#cart-drawer-discount-code-info-text');
                        discountInfoText.html("<b>" + discountCode + "</b> couldn't be used, please check at checkout page.")
                            .show();
                        setTimeout(function() {
                            discountInfoText.hide();
                        }, 2000);
                    }
                
                updateCartDrawer();
            }).fail(function() {
                console.error('Error while applying discount.');
                updateCartDrawer();
            });
        } else {
            var discountTitles = discountSpan.find('.cart-drawer-discount-code-title');
            var titlesParam = discountTitles.map(function() {
                return $(this).text().trim();
            }).get().join(',');

            var url = '/checkout?discount=' + encodeURIComponent(discountCode) + ',' + encodeURIComponent(titlesParam);

            $.get(url, function(data, status) {
                $('#discount-input').val('');

                    var discountAfter = discountSpan.find('.cart-drawer-discount-code-title');
                    var titlesParam1 = discountAfter.map(function() {
                        return $(this).text().trim().toLowerCase();
                    }).get().join(',');
              
               updateCartDrawer();

                    if (!titlesParam1.includes(discountCode)) {
                        var discountInfoText = $('#cart-drawer-discount-code-info-text');
                        discountInfoText.html("<b>" + discountCode + "</b> couldn't be used, please check at checkout page.")
                            .show();
                        setTimeout(function() {
                            discountInfoText.hide();
                        }, 2000);
                    }
              
            }).fail(function() {
                console.error('Error while applying discount.');
                updateCartDrawer();
            });
        }
    });
  
    $(document).on("click", ".cart-drawer-removecode", function(event) {
        event.preventDefault();
        $(".drawer__footer").addClass("active-drawer__footer");
    
        var discountSpan = $('#cart-drawer-discount-code-box');
        var allDiscountTitles = discountSpan.find('.cart-drawer-discount-code-box-span');
        var clickedSpan = $(this).closest('.cart-drawer-discount-code-box-span');
        var currentTitleValue = clickedSpan.find('.cart-drawer-discount-code-title').text().trim();
    // console.log("currentTitleValue"+currentTitleValue);
        var titlesParam = allDiscountTitles.map(function() {
            return $(this).find('.cart-drawer-discount-code-title').text().trim();
        }).get().filter(function(title) {
            return title !== currentTitleValue;
        }).join(',');
    
    // console.log("titlesParam"+titlesParam);
    
        var url = allDiscountTitles.length > 1
            ? '/checkout?discount=' + encodeURIComponent(titlesParam)
            : '/checkout?discount=' + encodeURIComponent();
    
        $.get(url)
            .done(function(data) {
                clickedSpan.remove();
                $('#discount-code-info-text').html("");
                updateCartDrawer();
            })
            .fail(function() {
                console.error('Error while removing discount.');
                updateCartDrawer();
            });
    });



 // 多规格 产品
  
  // 提交购物车表单
 $(document).on("click", ".drawer_select-variant,.drawer_select-option-text", function() {
    var optionlist = $(this).parents(".CartAddToCartForm");
    optionlist.find(".drawer_cart-product-option").removeClass('hide');   
    $(".drawer_select-option-overlayer").removeClass('hide');
   // drawer_select-option-text
 });


  
 $(document).on("click", ".drawer_select-option-overlayer", function() {

    $(".drawer_cart-product-option").addClass('hide');   
    $(".drawer_select-option-overlayer").addClass('hide');
   // drawer_select-option-text
 });

 $(document).on("click", ".cart-swatch-element", function() {
    var optionlist = $(this).parents(".custom-swatch");
    optionlist.find(".cart-swatch-element").removeClass('swatch-element-selected');
    optionlist.find(".cart-swatch-element input").prop('checked', false);
    $(this).addClass('swatch-element-selected');     
    $(this).find("input").prop('checked', true); 

   var alloption = $(this).parents(".CartAddToCartForm");
    var selectedValues = alloption.find(".swatch-element-selected label").map(function() {
        return $(this).text(); 
    }).get(); 
    var result = selectedValues.join(' / ');
    alloption.find(".drawer_select-option-text").html(result);
     
   var matchingOption = alloption.find("select[name='id'] option").filter(function() {
        return $(this).text().replace(/\s+/g, '') === result.replace(/\s+/g, ''); // 比较选项文本
    });

    if (matchingOption.length) {
        // 将匹配的选项的值更新到 input 中
        alloption.find(".drawer_select-option-box-addbutton input").val(matchingOption.val());
    }
   
   // drawer_select-option-text
 });


        $('.CartAddToCartForm').each(function() {
        var alloption = $(this);
        
        // Get selected labels, removing slashes and spaces
        var selectedValues = alloption.find(".cart-swatch-element.swatch-element-selected label").map(function() {
            return $(this).text().replace(/\s+/g, '').replace(/\//g, ''); 
        }).get(); 

        var result = selectedValues.join(' / ').replace(/\s+/g, '').replace(/\//g, '');
        
        // Update the display text
        // alloption.find(".drawer_select-option-text").html(result);

        // Find matching option
        var matchingOption = alloption.find("select[name='id'] option").filter(function() {
            return $(this).text().replace(/\s+/g, '').replace(/\//g, '') === result; // Compare trimmed values
        });

        if (matchingOption.length) {
            // Update the input with the matching option's value
            alloption.find("input.variants-input").val(matchingOption.val());
          alloption.find(".drawer_select-option-text").html(matchingOption.text());
        }
    });




  
  
  var swiperpartner = new Swiper(".swiper-recommended", {	
        slidesPerView: "auto", 
        spaceBetween: 15, 
  });
  if (swiperpartner.slides.length > 1) {
  $(".swiper-recommended").addClass('swiper-recommended-more');
}
 // 评论条数
  changeReviews();
  // 多规格产品end $(this).closest('cart-drawer').removeClass('active');


     var swiperpartner = new Swiper(".swiper-partner", {	
        slidesPerView: 1, 
        spaceBetween: 20, 
       loop:true,
        autoplay: {
          delay: 5000, // 自动播放延迟时间（单位为毫秒）
          disableOnInteraction: false, // 允许用户交互时保持自动播放
        },
  });
  
  
}

  // 更新购物车数量
  function updateCartDrawerQuantity(lineItemId, quantity) {
    $.post(`/cart/change.js?line=${lineItemId}&quantity=${quantity}`, function() {
      updateCartDrawer(); // 更新购物车内容
    }).fail(function(error) {
      updateCartDrawer();
      console.error('Error updating item quantity:', error);
    });
  }

  // 删除产品
  function removeCartDrawerItem(lineItemId) {
    $.post(`/cart/change.js?line=${lineItemId}&quantity=0`, function() {
      updateCartDrawer(); // 更新购物车内容
    }).fail(function(error) {
      updateCartDrawer();
      console.error('Error removing item:', error);
    });
  }

  
    function addProductToCart(productId, quantity) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { id: productId, quantity: quantity },
            dataType: 'json',
            success: function() {
                console.log("Product added to cart successfully!");
                updateCartDrawer();
            },
            error: function(xhr, status, error) {
                console.error("Error adding product to cart: " + error);
            }
        });
    }

     function changeReviews(){
       $('.recommended_item').each(function() {
            // 获取当前推荐项中的 .jdgm-prev-badge
            var badge = $(this).find('.jdgm-prev-badge');
            
            // 获取 data-number-of-reviews 的值
            var reviewCount = badge.data('number-of-reviews');
            
            // 将 .jdgm-prev-badge__text 的文本替换为 reviewCount
              $(this).find('.custom-review').text('(' + reviewCount + ')');
            
        });
    }
  
  // freegift end
    
  // 初始化购物车控制
  newContrlCartDrawer();


    
clearInterval(checkDrawercart);
    }

}, 1000);